<template>
    <ul id="list-tasks">
      <li>
        
       <!--pc view -->
       <div id='oblea' v-show="!mobileView">
            <div id='seccion1'>
              <p id='titulo'>{{numeroPedido}}</p>   
              <p id='fecha'>{{item.Fecha}}</p>
              <span class='label'>Items:</span> 
              <span class='value'> {{item.CantidadItems}} </span>
              <span class='label'>Precio Total:</span>
              <span class='value'>${{item.MontoTotal | formatMoney}}</span>
            </div> 
            <div id='seccion2'>
             <div id='seccion3'>
               <img id='iconVer' :class="{iconVerVisible:item.Estado!=99,iconVerInvisible:item.Estado==99}" src="/dist/icon-ver.png" @click='btnVerDetalle'/>
               <span id='labelVer' :class="{labelR:item.Estado!=99,labelRInvisible:item.Estado==99}" style="margin-right:10px;  margin-left:10px" @click='btnVerDetalle'> VER</span>
               <div :id="`circulo${item.Estado}`"  style="margin-left:40px"> </div>
               <span class="labelR"> {{estado(item.Estado)}} </span>
               <img id='btnEliminarBorrador' v-show='item.Estado==99'  @click="btnEliminarBorrador"  src="/dist/icon-delete.png"  style= "width:15px;height:15px;margin-left:22px">   
             </div> 
             <div id='seccion4'>
               <button id="btnIrCarrito"  v-show='item.Estado==99'  @click="btnIrCarrito">IR AL CARRITO</button>
             </div> 
          </div> 
       </div>


       <!--mobile view -->
       <div class="fv ct" style="width: 100vw;" v-show="mobileView">
         <div class="fh lc" style="width: 100%; height:70px;">
           <div class="fv lc" style="width: 60%; height:100%;">
             <div class="fh lc" style="width: 100%">
               <div class="fh lt" style="margin-left: 15px; color: #5D6770; font-size: 16px; font-weight: 600; width: 100px;">{{numeroPedido}}</div>     
               <div class="fh lt" style="margin-left: 10px; color: #5D6770; font-size: 8px;"> (Items: {{item.CantidadItems}}) </div>      
             </div>
             <div class="fv lt" style="margin-left: 15px; color: #5D6770; font-size: 8px;">{{item.Fecha}}</div>     
             <div class="fh lt" style="margin-left: 15px; width: 100%"> 
              <div class="fh lt" style="width: 70%;margin-top: 10px; color: #5D6770; font-size: 10px;"> Precio Total: &nbsp; <b> ${{item.MontoTotal | formatMoney}} </b> </div>      
             </div>    
           </div>       
           <div class="fv lc" style="width: 30%; height:100%;">
             <div class="fh lc" style="width: 100%;">
               <div :id="`circulo${item.Estado}`"  style="margin-left:5px"> </div>
               <span class="labelR"> {{estado(item.Estado)}} </span>
             </div>
             <div class="fh cc" style="width: 100%;" v-show='item.Estado==99'>
               <img id='btnEliminarBorrador' @click="btnIrCarrito"  src="/dist/carrito-gris.svg"  style= "width:20px;height:20px;margin-left: 15px;margin-right: 20px">  
               <img id='btnEliminarBorrador' @click="btnEliminarBorrador"  src="/dist/icon-delete.png"  style= "width:20px;height:20px;">  
             </div>
           </div>       
           <div class="fv cc" v-show='item.Estado!=99' style="width: 10%; height:100%;">
             <img @click='btnVerDetalle'  src="/dist/icon_right.png"  style= "width:10px;height:10px;">  
           </div>       
         </div>       
          <div class="fh lt" style="width: 100%; height: 1px; background: #dddddd"></div>
       </div>

      </li>
    </ul>
  </template>
  
  
  <script>
  
    import axios from 'axios'
    
   // Estado de los pedidos. (TODOS=-1, PENDIENTE = 0,CONFIRMADO = 1,ELIMINADO = 2,PROCESANDO = 3, GUARDADO = 99)
  
    export default {
      name: 'item-estado-pedido',
      props: ['item'],

      computed: {
        numeroPedido(){
          if (this.item.Numero > 0)
          {
            return 'Pedido '+this.item.Numero
          }
          else
          {
            return 'Borrador'
          }
        }
      },

      data() {
         return {
           mes: ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
           productos:[],
           replicaPedido:[],
           mobileView:false
         }
      },
  
      methods:{
  

        onResize() {
          if (window.innerWidth > 600) 
          {
            this.mobileView=false;
          }
          else 
          {
            this.mobileView=true;
          }
        },

        estado: function (e){
          if (e==0)
          {
            return 'PENDIENTE';  
          }
          else if (e==1)
          {
            return 'CONFIRMADO';  
          }
          else if (e==2)
          {
            return 'ELIMINADO ';  
          }
          else if (e==3)
          {
            return 'PROCESANDO ';  
          }
          else if (e==99)
          {
            return 'GUARDADO ';  
          }
        },
  
    
        btnVerDetalle () {
          this.$store.commit('pedido/savePedidoId',this.item); 
          this.$router.push({ name: 'pedidoCms' });
        },
  

        btnIrCarrito () {
          if (this.$store.state.pedido.carrito.length > 0)
          {
            var obj = {
                        txt:'Existe un nuevo pedido en curso, si recupera el pedido guardado los ítems cargados en el nuevo pedido se perderán.',
                        txtBtnCancel:'Cancelar',
                        txtBtnOk:'Continuar',
                        fCancel:null,
                        fOk:this.replicarPedido
                      }
            this.$store.commit('popup/open',obj);
          }
          else
          {
            this.replicarPedido();
          }
        },
   

       btnEliminarBorrador () {
         var obj = {
                    txt:'¿Eliminar el borrador de pedido?',
                    txtBtnCancel:'Cancelar',
                    txtBtnOk:'Aceptar',
                    fCancel:null,
                    fOk:this.eliminarBorrador
                   }
         this.$store.commit('popup/open',obj);
       },

  
        replicarPedido() {
            this.$store.commit('loader/start')
            var url = '/WebSalesPedidosListado/'+String(this.item.Id)+'?Tipo=1'
            axios.get(url,{
              headers:{
                          Token:        this.$store.state.user.usuario.Token,
                          ClientSecret: this.$store.state.entorno.clientSecret,
                          EmpresaId:    this.$store.state.entorno.idEmpresa
              }
            }).then((response) => {
              if (response.data.Code == 0)
              {
                this.$store.commit('pedido/eliminarPedido');
                this.$store.commit('pedido/setBorradorId',this.item.Id);
                this.productos = response.data.Productos
                console.log(this.productos)
                this.productos.forEach((e) => {
                   
                  var prod = this.$store.state.pedido.productos.find(elem => elem.Id === e.ProductoId)

                  if (prod != null) {
                      var nuevoProducto = {
                            id: prod.Id,
                            idCategoria: prod.CategoriaId,
                            idSubcategoria: prod.SubCategoriaId,
                            producto: prod.Nombre,
                            descripcion: prod.Nombre,
                            precioLista: prod.Precio,
                            precio: prod.Precio,
                            descuento: e.Descuento,
                            porcentajeDescuento:(e.Descuento/prod.Precio)*100,
                            porcentajeImpuesto: prod.PorcentajeImpuesto,
                            cantidad: e.Cantidad,
                            peso:prod.Peso,
                            ImagenUrl:prod.ImagenUrl,
                            promocionId:0,
                            unidadesPorPedido:prod.UnidadesPorPedido,
                            unidadesMinimaVenta:prod.UnidadesMinimaVenta,
                            tipoOblea:1
                      }
                      this.replicaPedido.push(nuevoProducto);
                  }  
                  else {
                    var promo = this.$store.state.pedido.promociones.find(elem => elem.Id === e.PromocionId)
                    if (promo != null)
                    {
                      var nuevaPromo = {
                      id: e.PromocionId,
                      producto: promo.Nombre,
                      descripcion: promo.Observacion, 
                      precio: promo.PrecioPromocional, 
                      cantidad: e.Cantidad,
                      idCategoria:-1,
                      idSubcategoria:-1,
                      ImagenUrl:promo.ImagenUrl,
                      tipoOblea:1
                      }
                      this.replicaPedido.push(nuevaPromo);
                    }  
                  }
                 
                })
                this.$store.commit('loader/stop')
                this.$store.commit('pedido/replicarPedido',this.replicaPedido);
                this.$router.push({name: 'pedido'});
              }
              else if (response.data.Code == 99)
              {
                alert(response.data.Message) 
                this.$router.push({name: 'login'});
              }
              else
              {
                console.log(">>>>"+response.data.Message);
                alert(response.data.Message);  
              }
            },(error) => {
              console.log(error)
              alert(error);
            })
        },
  
  
        eliminarBorrador () {
          this.$store.commit('loader/start')
          var bdParam = { BorradorId:this.item.Id,
                          ClienteId:this.$store.state.user.cliente.Id,	
                          EmpleadoId:this.$store.state.user.usuario.EmpleadoId
                        }

          axios.put('/WebSalesBorrador',bdParam,{
           headers:{
                    Token:        this.$store.state.user.usuario.Token,
                    ClientSecret: this.$store.state.entorno.clientSecret,
                    EmpresaId:    this.$store.state.entorno.idEmpresa
                  }
           }
          ).then((response) => {
           this.$store.commit('loader/stop')
           if (response.data.Code == 0)
           {
            this.$emit('borradorEliminado');
           }
           else if (response.data.Code == 99)
           {
             alert(response.data.Message);
           }
           else
           {
             alert(">>>>"+response.data.Message);
             console.log(">>>>"+response.data.Message);
           }
        },(error) => { console.log(error) 
            alert(error);  })
         },


        getFecha (millis) {
         var sFecha='';
         var date = new Date(millis);
         sFecha = date.getDate();
         sFecha = sFecha + ' ' + this.mes[date.getMonth()];
         sFecha = sFecha + ' ' + date.getFullYear();
         sFecha = sFecha + ' - ' + date.getHours();
         sFecha = sFecha + ':' + date.getMinutes() + 'hs';
         return sFecha;  
        }
      },

     mounted() {
       this.onResize()
     },

     created() {
       window.addEventListener('resize', this.onResize)
     },

      beforeDestroy() {
       window.removeEventListener('resize', this.onResize)
     }
    
    }
  </script>
  
  
  <style scoped>
    
  * {
    margin:  0;
    padding: 0;
  }
    
  .texto{
  color: #717A82;
  }
   
  
  #btnIrCarrito{
    width: 105px;
    height: 25px;
    margin-right: 10px;
    font-size: 9px;
    border-style: solid;
    border:none; 
    background: #44C7F4; 
    border-radius: 20px;  
    color: #ffffff;
    outline: none;
  }
  
  
  #btnIrCarrito:hover{
      cursor: pointer;
    }    
   
  
  
  .labelR {
    font-size: 11px; 
    vertical-align: middle;
  }
  

  .labelRInvisible {
    font-size: 11px; 
    vertical-align: middle;
    opacity: 0;
  }
  
  
  .iconVerVisible {
    width:15px;
    height:15px;
  }
  
  
  .iconVerInvisible {
    width:15px; 
    height:15px;
    opacity:0;
  }
  
    
  /*pendinte 0 */
  #circulo0 {
    width: 10px;
    height:10px;
    display: block;
    border-radius: 100%;
    background: #FFC107;  
    margin: 10px;
   }
  
  
  
  /*confirmado 1*/
  #circulo1 {
    width: 10px;
    height:10px;
    display: block;
    border-radius: 100%;
    background: #4CD964;  
    margin: 10px;
  }
  
  
  
  /*eliminado 2*/
  #circulo2 {
    width: 10px;
    height:10px;
    display: block;
    border-radius: 100%;
    background: red;  
    margin: 10px;
  }
    
  
  /*procesanso 3*/
  #circulo3 {
    width: 10px;
    height:10px;
    display: block;
    border-radius: 100%;
    background: yellow;  
    margin: 10px;
  }
    
  
  /*guardado 99*/
  #circulo99 {
    width: 10px;
    height:10px;
    display: block;
    border-radius: 100%;
    background: #D0D2D3;  
    margin: 10px;
  }
 
  
  #oblea {
    width: 630px;
    height:80px;
    background: #ffffff;  
    border-style: solid;
    border-width: 1px;
    border: 1px solid #dddddd;
    display: flex;
    align-items: flex-start; 
  }
  
  
  #seccion1{
    width: 64%;
    height:100%;
    background: #ffffff;  
  }
  

  #seccion2{
      width: 36%;
      height:100%;
      background: #ffffff;  
      display: flex;            
      flex-direction: column;  
      justify-content: center;  
      align-items: flex-start;  
    }
    
    
    
    #seccion3 {
      width: 100%;
      height:30px;
      background: #ffffff;  
      display: flex;            
      flex-direction: row;  
      justify-content: flex-start;  
      align-items: center;  
      margin-top: 0px;
    }
    
    
    
    #seccion4 {
      width: 100%;
      height:30px;
      background: #ffffff;  
      display: flex;            
      justify-content: flex-end;  
      align-items: center;  
      margin-top: 5px;
    }
 
  
  
  #titulo{
    font-size: 16px;
    color: #656E76;
    margin-top: 12px;
    margin-left: 35px;
    font-weight: 500;
  }
  
  #fecha{
    font-size: 10px;
    color: #656E76;
    margin-top: 3px;
    margin-left: 35px;
    margin-bottom: 10px;
  }
  
  .label{
    font-size: 12px;
    font-weight: 500;
    color: #656E76;
    margin-top: 10px;
    margin-left: 35px;
  }
  
  .value{
    font-size: 12px;
    color: #656E76;
    margin-top: 10px;
  
  }
  
  .ver-enviado{
    font-size: 12px;
    color: #656E76;
    vertical-align: middle;
    margin-top: 25px;
    margin-left: 35px;
  } 
  
  .icon{
    width: 10px;
    height: 10px;
    vertical-align: middle;
  }
  
  
  #iconVer:hover { cursor: pointer; }
  #labelVer:hover { cursor: pointer; }
  #btnEliminarBorrador:hover { cursor: pointer; }
  
  
   </style>


// WEBPACK FOOTER //
// src/components/views/estadoPedido/itemEstadoPedido.vue